<ng-container *ngIf="isValueSet">
	<span [class]="'badge ' + class">
		<ng-container *ngIf="value; else caseNo">{{ textTrue }}</ng-container>
	</span>
	<ng-template #caseNo>{{ textFalse }}</ng-template>
</ng-container>
